// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2ZNN2","select":"Header_select__3YK4j","clinic":"Header_clinic__1Lxgl"};